module.exports = __webpack_public_path__ + "static/media/dataDownloadIT.7b6951b1.md";